import { useCallback, useSyncExternalStore } from "react";
import { themeStore, type ThemePreference, type ThemeState } from "../lib/theme.js";

/**
 * The scheme preference and what it resolved to. Reads the app store that
 * `main.tsx` starts, so every subscriber sees one answer and a change made in
 * Settings reaches the toaster, the charts, and any other scheme-aware
 * component in the same tick.
 */
export function useTheme(): ThemeState & { setPreference: (preference: ThemePreference) => void } {
  const state = useSyncExternalStore(themeStore.subscribe, themeStore.getSnapshot, themeStore.getSnapshot);
  const setPreference = useCallback((preference: ThemePreference) => themeStore.setPreference(preference), []);
  return { ...state, setPreference };
}
